import { lazy } from 'react';
import { ORG_PERMISSIONS } from './constants';

const OrganizationListPage = lazy(() => import('./pages/OrganizationListPage'));
const OrganizationDetailPage = lazy(() => import('./pages/OrganizationDetailPage'));

export const organizationRoutes = [
  {
    path: '/organizations',
    element: OrganizationListPage,
    permission: ORG_PERMISSIONS.READ,
    nav: { labelKey: 'nav.organizations', icon: 'BankOutlined', group: 'orgMgmt' },
  },
  {
    path: '/organizations/:id',
    element: OrganizationDetailPage,
    permission: ORG_PERMISSIONS.READ,
    nav: null,
  },
];
